import Clarity from '@microsoft/clarity';

// CookieYes category that gates Microsoft Clarity's cookies (_clck / _clsk) in
// this project's CookieYes dashboard. Check under Cookie categorization there
// and adjust if it differs ('analytics' | 'functional' | 'performance' | ...).
const CONSENT_CATEGORY = 'analytics'

interface CkyConsent {
    categories: Record<string, boolean>
}

export default defineNuxtPlugin((nuxtApp) => {
    const id = nuxtApp.$config.public.clarityId
    const featureEnabled = nuxtApp.$config.public.feature.clarity

    if (!featureEnabled) {
        console.log("Clarity feature is not enabled")
        return;
    }

    if (!id) {
        console.log('Clarity disabled (no ID provided)')
        return;
    }

    let started = false
    const startClarity = () => {
        if (started) return
        started = true
        setTimeout(() => {
            Clarity.init(id)
            console.log('Clarity initialized')
        }, 4000);
    }

    const hasConsented = (): boolean => {
        const consent = (window as unknown as { getCkyConsent?: () => CkyConsent }).getCkyConsent?.()
        return !!consent?.categories?.[CONSENT_CATEGORY]
    }

    // Returning visitor who already gave consent in a previous visit.
    document.addEventListener('cookieyes_banner_loaded', () => {
        if (hasConsented()) startClarity()
    })

    // First-time consent choice, or a later change via the preferences center.
    document.addEventListener('cookieyes_consent_update', (e) => {
        const detail = (e as CustomEvent<{ accepted: string[] }>).detail
        if (detail?.accepted?.includes(CONSENT_CATEGORY)) startClarity()
    })
})